import { ModalContext } from 'app/app';
import axios from 'axios';
import { IconedButton } from 'components/IconedButton';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  AuthContext,
  Grid,
  Loader,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';

export function Companies(props) {
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const auth = useContext(AuthContext);
  const context = useContext(ViewContext);
  const { setModal } = useContext(ModalContext);

  function view(row) {
    window.location.href = '/app/company/' + row.id + '/info';
  }

  async function runAPI(page, search, firstTime) {
    await axios
      .get(
        `/api/company?page=${page}&search=${search}&account_id=${auth.user.account_id}`
      )
      .then(async (res) => {
        setPayload(res.data.data);

        var tempData = [];
        var format = new DateUtils();
        const timezone = await format.getTimezone();

        res.data.data.data.map(async (value, index) => {
          tempData.push({
            id: value.id,
            'DOT Number': value.dot_number,
            'Company Name': value.name,
            'Owner Name': value.owner_name,
            Email: value.email,
            Phone: value.phone,
            'Date Created': format.timestamp(
              value.createdAt,
              timezone
            ),
          });
        });

        setLoading(false);
        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);

        context.notification.show(
          'Failed to load table data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    runAPI(page, searchQueryString, false);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, '', true);
  }, []);

  return (
    <Animate type="pop">
      <>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div
              style={{
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                <IconedButton
                  size="160px"
                  color="#d32425"
                  textColor="white"
                  icon="plus-circle"
                  text="Add Company"
                  marginRight
                  action={async () => {
                    setModal({
                      name: 'company_modal',
                      stage: 1,
                      action: () => runAPI(page, searchQueryString),
                    });
                  }}
                />
              </div>
            </div>
            <Grid cols="1">
              <div className={styles.wrapper}>
                <div style={{ marginBottom: 30 }}>
                  <Search
                    callback={(query) => {
                      setSearchQueryString(query);
                    }}
                  />
                </div>
                <Table
                  data={data}
                  hide={['id', 'company_id']}
                  loading={loading}
                  badge={{
                    col: 'status',
                    color: 'gray',
                    condition: [
                      { value: 'created', color: 'gray' },
                      { value: 'submitted', color: 'blue' },
                      { value: 'declined', color: 'red' },
                      { value: 'requested bind', color: 'purple' },
                      { value: 'active', color: 'green' },
                    ],
                  }}
                  actions={{
                    custom: [
                      {
                        icon: 'log-in',
                        action: view,
                        tooltip: 'View company details',
                      },
                    ],
                  }}
                />
                {payload && !loading && (
                  <Pagination
                    pagesCount={payload.pages_count}
                    active={payload.page}
                    onChange={async (newPage) => {
                      setPage(newPage);
                      runAPI(newPage, searchQueryString, false);
                    }}
                  />
                )}
              </div>
            </Grid>
          </>
        )}
      </>
    </Animate>
  );
}
